import { useSyncExternalStore } from 'react';
import { BASE_LOCALE, type Locale, locale, subscribeLocale } from './index';

/**
 * Locale corrente, reativo.
 *
 * O catálogo é um módulo, não um contexto — `t()` é uma função pura que
 * qualquer arquivo importa sem provider. O preço disso é que trocar o idioma
 * **não** repinta nada sozinho, e é este hook que fecha o buraco: quem o chama
 * re-renderiza na troca. Basta chamá-lo uma vez no topo (`App`) para o console
 * inteiro repintar; telas memoizadas que quiserem repintar sozinhas o chamam.
 *
 * `getServerSnapshot` devolve a base porque no SSR/pré-render não há
 * `localStorage` — e o `useSyncExternalStore` exige que os dois snapshots
 * concordem na primeira pintura.
 */
export function useLocale(): Locale {
  return useSyncExternalStore(subscribeLocale, locale, () => BASE_LOCALE);
}
